var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(180 40 40)",
    fill: "#3A2159"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 20L16.7 16.1C16.5167 15.9167 16.425 15.6834 16.425 15.4C16.425 15.1167 16.5167 14.8834 16.7 14.7C16.8834 14.5167 17.1167 14.425 17.4 14.425C17.6834 14.425 17.9167 14.5167 18.1 14.7L22.7 19.3C22.8 19.4 22.8709 19.5084 22.9125 19.625C22.9542 19.7417 22.975 19.8667 22.975 20C22.975 20.1334 22.9542 20.2584 22.9125 20.375C22.8709 20.4917 22.8 20.6 22.7 20.7L18.1 25.3C17.9167 25.4834 17.6834 25.575 17.4 25.575C17.1167 25.575 16.8834 25.4834 16.7 25.3C16.5167 25.1167 16.425 24.8834 16.425 24.6C16.425 24.3167 16.5167 24.0834 16.7 23.9L20.6 20Z",
    fill: "#AE6FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrow);
export default __webpack_public_path__ + "static/media/nextarrow.41ef51d79aae24f6d65d71f3b07d3e00.svg";
export { ForwardRef as ReactComponent };